import {createTheme} from "@mui/material/styles";

export const mdTheme = createTheme({
  palette: {
    primary: {
      main: '#CCAF9B',
      dark: '#9E775C',
      light: '#F6E3D6',
      contrastText: '#000000'
    },
    secondary: {
      main: '#CE93D8',
      dark: '#AB47BC',
      light: '#F3E5F5',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#F44336',
      dark: '#D32F2F',
      light: '#F3E5F5',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ED6C02',
      dark: '#F57C00',
      light: '#FFB74D',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#29B6F6',
      dark: '#0288D1',
      light: '#4FC3F7',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#66BB6A',
      dark: '#388E3C',
      light: '#81C784',
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        fontSize: 16
      }
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  }
});